import { render, staticRenderFns } from "./CreditNoteReport.vue?vue&type=template&id=2edf0736"
import script from "./CreditNoteReport.vue?vue&type=script&lang=js"
export * from "./CreditNoteReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports